const Subprocessors = () => (
  <div className="Subprocessors">
    <div className="Subprocessors-inner">
      <div className="Subprocessors-text">
        <p>
          <i>Current as of: July 20, 2022</i>
        </p>
        <p>
          Welcome to Mutiny's Subprocessor repository page where we maintain a current list of Subprocessors authorized
          to process customer data for Mutiny's services. Mutiny imposes data protection terms with each Subprocessor
          regarding their security controls and applicable regulations for the protection of personal data.
        </p>

        <h3>Subprocessor List</h3>
        <div>
          <table>
            <thead>
              <th>Entity Name</th>
              <th>Entity Type</th>
              <th>Entity Location</th>
            </thead>
            <tbody>
              <tr>
                <td>Amazon Web Services</td>
                <td>Cloud Service Provider</td>
                <td>USA</td>
              </tr>
              <tr>
                <td>Elastic Cloud</td>
                <td>Cloud Service Provider</td>
                <td>USA</td>
              </tr>
              <tr>
                <td>Datadog</td>
                <td>System Metrics and Logging</td>
                <td>USA</td>
              </tr>
              <tr>
                <td>Intercom</td>
                <td>In-application Customer Support</td>
                <td>USA</td>
              </tr>
              <tr>
                <td>Bugsnag</td>
                <td>Error Reporting</td>
                <td>USA</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default Subprocessors;
